module.exports = __webpack_public_path__ + "img/logo-cutuglagua.a19ed5b3.png";